/**
 * Safe money-format patch:
 * - Does NOT change how amounts are calculated (cents vs rupees)
 * - Only strips trailing `.00` / `,00` from the formatted string
 *
 * This wraps the theme's own formatMoney instead of re‑implementing it,
 * so 3rd‑party apps that pass different units still get correct amounts.
 */
(function () {
  /**
   * Strip only a terminal decimal ".00" (e.g. "Rs. 6,000.00" → "Rs. 6,000").
   * Do NOT strip ",00" — that matches thousands in "6,000" and breaks amounts.
   */
  function stripTrailingZeroDecimals(formatted) {
    if (typeof formatted !== 'string') return formatted;
    return formatted.replace(/\.00$/, '');
  }

  /** Theme formatMoney often returns "<span class=\"money\">…</span>" — plain text only. */
  function moneyFormatToPlainText(formatted) {
    if (typeof formatted !== 'string') return formatted;
    if (formatted.indexOf('<') === -1) return formatted;
    var el = document.createElement('div');
    el.innerHTML = formatted;
    return (el.textContent || el.innerText || '').trim();
  }

  function wrapFormatMoney() {
    if (!window.theme || typeof window.theme.formatMoney !== 'function') return;
    if (window.theme._mnshMoneyPatched) return;

    var original = window.theme.formatMoney;

    window.theme.formatMoney = function (cents, format) {
      var out = original.call(window.theme, cents, format);
      if (typeof out === 'string' && window.theme.stripTrailingZeroDecimals) {
        return window.theme.stripTrailingZeroDecimals(out);
      }
      return out;
    };

    window.theme._mnshMoneyPatched = true;
  }

  window.theme = window.theme || {};
  window.theme.stripTrailingZeroDecimals = stripTrailingZeroDecimals;
  window.theme.moneyFormatToPlainText = moneyFormatToPlainText;

  // Try immediately, then again once DOM is ready (in case theme.js loads late).
  wrapFormatMoney();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapFormatMoney);
  } else {
    wrapFormatMoney();
  }
})();
